import { useEffect, useState } from "react";
import { AdminLayout } from "../../components/Layouts";
import { api, readUser, errMsg } from "../../lib/api";

export default function AdminSiteSettings() {
  const user = readUser();
  const [settings, setSettings] = useState(null);
  const [notice, setNotice] = useState({ ok: false, msg: "" });

  useEffect(() => { api.get("/admin/settings").then((r) => setSettings(r.data)).catch(() => {}); }, []);

  async function save(e) {
    e.preventDefault();
    setNotice({ ok: false, msg: "" });
    try {
      await api.put("/admin/settings", { ...settings, required_confirmations: Number(settings.required_confirmations), minimum_deposit: Number(settings.minimum_deposit), minimum_withdrawal: Number(settings.minimum_withdrawal), withdrawal_fee: Number(settings.withdrawal_fee), referral_rates: (settings.referral_rates || []).map(Number) });
      setNotice({ ok: true, msg: "Site ayarları güncellendi." });
    } catch (e) { setNotice({ ok: false, msg: errMsg(e) }); }
  }
  if (!settings) return <AdminLayout user={user} active="Site Ayarları"><div className="empty-activity"><p>Yükleniyor…</p></div></AdminLayout>;
  return (
    <AdminLayout user={user} active="Site Ayarları">
      <section className="admin-panel">
        <div className="admin-panel-title"><div><span className="eyebrow">GENEL</span><h2>Site Ayarları</h2></div></div>
        {notice.msg && <div className={notice.ok ? "success" : "error"}>{notice.msg}</div>}
        <form onSubmit={save} className="pkg-form">
          <label>Site Başlığı<input data-testid="site-title" value={settings.site_title || ""} onChange={(e) => setSettings({ ...settings, site_title: e.target.value })} /></label>
          <label>Destek E-postası<input data-testid="site-support" value={settings.support_email || ""} onChange={(e) => setSettings({ ...settings, support_email: e.target.value })} /></label>
          <label className="full-row">Telegram URL<input data-testid="site-telegram" value={settings.telegram_url || ""} onChange={(e) => setSettings({ ...settings, telegram_url: e.target.value })} /></label>
          <button className="btn btn-accent" data-testid="site-save">Kaydet</button>
        </form>
      </section>
    </AdminLayout>
  );
}
